// Translation files for PROP INDEXA
// Supported languages: English, Spanish, French, Portuguese, Arabic, Chinese, Hausa, Afrikaans, Igbo, Yoruba

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', rtl: true },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ha', name: 'Hausa', flag: '🇳🇬' },
  { code: 'af', name: 'Afrikaans', flag: '🇿🇦' },
  { code: 'ig', name: 'Igbo', flag: '🇳🇬' },
  { code: 'yo', name: 'Yorùbá', flag: '🇳🇬' }
];

// English translations (base)
const en = {
  // Navigation
  nav: {
    howItWorks: 'How It Works',
    accountPlans: 'Account Plans',
    tradingRules: 'Trading Rules',
    dashboard: 'Dashboard',
    faq: 'FAQ',
    login: 'Login',
    getFunded: 'Get Funded',
    logout: 'Logout'
  },
  // Hero Section
  hero: {
    badge: 'Premium Prop Trading Firm',
    title: 'Trade Synthetic Indices with',
    titleHighlight: 'Institutional Capital',
    subtitle: 'Get instant funding up to $50,000 and trade Deriv Synthetic Indices 24/7. No evaluation required for INSTANT plans.',
    instantFunding: 'Instant Funding',
    profitSplit: '80% Profit Split',
    trading247: '24/7 Trading',
    getFundedNow: 'Get Funded Now',
    viewRules: 'View Rules'
  },
  // Stats
  stats: {
    fundedTraders: 'Funded Traders',
    totalPayouts: 'Total Payouts',
    successRate: 'Success Rate',
    maxCapital: 'Max Capital'
  },
  // Account Plans
  plans: {
    title: 'Choose Your Account',
    subtitle: 'Select the plan that matches your trading style and goals',
    instant: 'INSTANT',
    oneStep: '1-STEP',
    instantDesc: 'Get funded immediately with no evaluation phase',
    oneStepDesc: 'Pass one evaluation phase to get funded',
    accountSize: 'Account Size',
    price: 'Price',
    dailyDrawdown: 'Daily Drawdown',
    maxDrawdown: 'Max Drawdown',
    profitTarget: 'Profit Target',
    profitSplit: 'Profit Split',
    minTradingDays: 'Min Trading Days',
    payoutFrequency: 'Payout Frequency',
    leverage: 'Leverage',
    consistencyRule: 'Consistency Rule',
    none: 'None',
    optional: 'Optional',
    getStarted: 'Get Started',
    popular: 'Popular',
    noEvaluation: 'No Evaluation',
    evaluation: 'Evaluation',
    features: 'Features',
    allFeatures: 'All features included',
    instantFunding: 'Instant Funding',
    noTimeLimits: 'No Time Limits',
    allStrategies: 'All Strategies Allowed',
    eaAllowed: 'EA Trading Allowed',
    scalpingAllowed: 'Scalping Allowed',
    weekendHolding: 'Weekend Holding Allowed'
  },
  // How It Works
  howItWorks: {
    title: 'How It Works',
    subtitle: 'Four simple steps to start trading with institutional capital',
    step1Title: 'Choose Your Account',
    step1Desc: 'Select from Instant or 1 step account based on your trading style and capital needs',
    step2Title: 'Start Trading',
    step2Desc: 'Trade Deriv Synthetic Indices with institutional-grade risk management',
    step3Title: 'Meet Requirements',
    step3Desc: 'Follow our transparent rules and demonstrate consistent profitability',
    step4Title: 'Withdraw Profits',
    step4Desc: 'Request payouts within 24-72 hours with your profit split'
  },
  // Trading Rules
  tradingRules: {
    title: 'Trading Rules',
    subtitle: 'Clear and transparent rules designed for your success',
    instantRules: 'Instant Account Rules',
    oneStepRules: '1-Step Account Rules',
    rule1Title: 'Daily Drawdown',
    rule1Desc: 'Maximum daily loss limit based on your account equity',
    rule2Title: 'Maximum Drawdown',
    rule2Desc: 'Total drawdown limit from your starting balance',
    rule3Title: 'Profit Target',
    rule3Desc: '10% profit target during evaluation phase',
    rule4Title: 'Max Open Risk',
    rule4Desc: '1% maximum open risk per trade',
    rule5Title: 'Profit Consistency',
    rule5Desc: 'No single trading day can contribute more than 25% of total profit at withdrawal',
    rule6Title: 'Payout Cycle',
    rule6Desc: 'Request withdrawals every 10 days with 80% profit split',
    rule7Title: 'Leverage & Instruments',
    rule7Desc: '1:1000 leverage on Synthetic Indices - 24/7 trading available',
    rule8Title: 'Minimum Trading Days',
    rule8Desc: 'Optional - trade at your own pace with no minimum requirements',
    rule9Title: 'No Time Limit',
    rule9Desc: 'Trade at your own pace with no time restrictions',
    rule10Title: 'All Strategies',
    rule10Desc: 'EAs, scalping, and all trading styles allowed'
  },
  // Features
  features: {
    title: 'Why Choose Us',
    subtitle: 'Industry-leading features designed for serious traders',
    feature1Title: 'Instant Funding',
    feature1Desc: 'Get funded immediately after purchase. No evaluation challenges, start trading right away.',
    feature2Title: 'Fast Payouts',
    feature2Desc: 'Withdraw your profits within 24-72 hours. Multiple payment methods supported.',
    feature3Title: 'Transparent Rules',
    feature3Desc: 'Clear, straightforward trading rules. No hidden conditions or surprise limitations.',
    feature4Title: 'Real-Time Dashboard',
    feature4Desc: 'Track your performance with advanced analytics and risk metrics in real-time.',
    feature5Title: 'Institutional Risk Model',
    feature5Desc: 'Professional risk management systems protecting both trader and firm.',
    feature6Title: '24/7 Support',
    feature6Desc: 'Expert support team available around the clock to assist with any questions.'
  },
  // FAQ
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about our prop trading program',
    q1: 'How does instant funding work?',
    a1: 'Once you purchase an account, you get immediate access to your funded account. No evaluation phase required. Start trading Deriv Synthetic Indices right away with our capital.',
    q2: 'What are Deriv Synthetic Indices?',
    a2: 'Synthetic indices are simulated markets that mimic real-world market movements. They are available 24/7, unaffected by natural events, and provide consistent volatility perfect for active trading.',
    q3: 'How fast are payouts processed?',
    a3: 'Withdrawal requests are typically processed within 24-72 hours. We support multiple payment methods including bank transfer, crypto, and e-wallets.',
    q4: 'Can I scale my account?',
    a4: 'Yes! Demonstrate consistent profitability and risk management, and you can scale up to larger account sizes with better profit splits.',
    q5: 'What happens if I breach the rules?',
    a5: 'If you violate daily drawdown or maximum drawdown limits, the account will be terminated. However, you can purchase a new account anytime to restart.'
  },
  // Footer
  footer: {
    description: 'Premium prop trading firm offering funded accounts for Deriv Synthetic Indices traders.',
    company: 'Company',
    aboutUs: 'About Us',
    howItWorks: 'How It Works',
    contact: 'Contact',
    careers: 'Careers',
    trading: 'Trading',
    accountPlans: 'Account Plans',
    tradingRules: 'Trading Rules',
    dashboard: 'Dashboard',
    payoutSystem: 'Payout System',
    resources: 'Resources',
    faq: 'FAQ',
    blog: 'Blog',
    tradingGuide: 'Trading Guide',
    videoTutorials: 'Video Tutorials',
    legal: 'Legal',
    termsConditions: 'Terms & Conditions',
    privacyPolicy: 'Privacy Policy',
    riskDisclosure: 'Risk Disclosure',
    cookiePolicy: 'Cookie Policy',
    allRightsReserved: 'All rights reserved.',
    riskWarning: 'Risk Warning: Trading involves substantial risk of loss and is not suitable for all investors.',
    riskDisclaimer: 'Risk Disclaimer',
    riskDisclaimerText: 'Trading synthetic indices involves substantial risk of loss and is not suitable for all investors. Past performance is not indicative of future results. You should carefully consider whether trading is suitable for you in light of your circumstances, knowledge, and financial resources. All trading decisions are made at your own risk.'
  },
  // Auth
  auth: {
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    fullName: 'Full Name',
    phone: 'Phone (Optional)',
    forgotPassword: 'Forgot Password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    welcomeBack: 'Welcome Back',
    loginSubtitle: 'Sign in to access your trading dashboard',
    createAccount: 'Create Account',
    registerSubtitle: 'Start your funded trading journey today',
    resetPassword: 'Reset Password',
    resetSubtitle: 'Enter your email to receive reset instructions',
    sendResetLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    referralCode: 'Referral Code (Optional)',
    agreeToTerms: 'I agree to the Terms & Conditions and Privacy Policy'
  },
  // Dashboard
  dashboard: {
    welcome: 'Welcome back',
    myAccounts: 'My Accounts',
    payoutRequests: 'Payout Requests',
    purchaseHistory: 'Purchase History',
    achievements: 'Achievements',
    affiliate: 'Affiliate',
    noAccounts: 'No Trading Accounts Yet',
    noAccountsDesc: 'Purchase a plan to get started with your funded trading account',
    viewPlans: 'View Plans',
    requestPayout: 'Request Payout',
    requestFundedPhase: 'Request Funded Phase',
    credentials: 'MT5 Login Credentials',
    loginId: 'Login ID',
    password: 'Password',
    server: 'Server',
    status: 'Status',
    phase: 'Phase',
    dailyDD: 'Daily DD',
    maxDD: 'Max DD',
    profitSplit: 'Profit Split',
    profitTarget: 'Profit Target',
    accountSize: 'Account Size',
    accountType: 'Account Type',
    createdAt: 'Created',
    notes: 'Notes',
    active: 'Active',
    funded: 'Funded',
    breached: 'Breached',
    pending: 'Pending',
    evaluation: 'Evaluation',
    copyCredentials: 'Copy Credentials',
    copied: 'Copied!',
    logout: 'Logout'
  },
  // Payout
  payout: {
    title: 'Request Payout',
    subtitle: 'Withdraw your trading profits',
    amount: 'Amount',
    profitAmount: 'Profit Amount',
    cryptocurrency: 'Cryptocurrency',
    walletAddress: 'Wallet Address',
    submit: 'Submit Request',
    cancel: 'Cancel',
    minAmount: 'Minimum payout amount',
    maxAmount: 'Maximum available',
    selectCrypto: 'Select cryptocurrency',
    enterWallet: 'Enter your wallet address',
    requestSubmitted: 'Payout request submitted successfully!',
    requestFailed: 'Failed to submit payout request',
    noProfits: 'No profits available for withdrawal',
    pendingRequest: 'You have a pending payout request'
  },
  // Payment
  payment: {
    completePayment: 'Complete Payment',
    selectCurrency: 'Select Payment Currency',
    amountToPay: 'Amount to Pay',
    payWith: 'Pay with',
    processing: 'Processing...',
    payNow: 'Pay Now',
    secure: 'Secure payment powered by NowPayments',
    orderSummary: 'Order Summary',
    accountType: 'Account Type',
    accountSize: 'Account Size',
    price: 'Price',
    total: 'Total'
  },
  // Affiliate
  affiliate: {
    title: 'Affiliate Program',
    subtitle: 'Earn 10% commission on every referral',
    yourLink: 'Your Referral Link',
    copyLink: 'Copy Link',
    linkCopied: 'Link copied!',
    stats: 'Your Stats',
    totalReferrals: 'Total Referrals',
    totalEarned: 'Total Earned',
    pendingBalance: 'Pending Balance',
    withdrawableBalance: 'Withdrawable Balance',
    withdrawThreshold: 'Minimum withdrawal: $150',
    requestWithdrawal: 'Request Withdrawal',
    referralHistory: 'Referral History',
    noReferrals: 'No referrals yet. Share your link to start earning!',
    withdrawalHistory: 'Withdrawal History',
    noWithdrawals: 'No withdrawal history',
    howItWorks: 'How It Works',
    step1: 'Share your unique referral link',
    step2: 'Friends sign up and purchase',
    step3: 'Earn 10% commission instantly',
    step4: 'Withdraw when balance reaches $150'
  },
  // Certificates
  certificates: {
    title: 'Achievements',
    subtitle: 'Your trading certificates and achievements',
    fundedCertificate: 'Funded Certificate',
    payoutCertificate: 'Payout Certificate',
    download: 'Download',
    share: 'Share',
    noCertificates: 'No Certificates Yet',
    noCertificatesDesc: 'Certificates are awarded when your account is funded or when you receive an approved payout.',
    shareAchievement: 'Share Your Achievement',
    shareMessage: 'Let the world know about your success!'
  },
  // Admin
  admin: {
    dashboard: 'Admin Dashboard',
    users: 'Users',
    accounts: 'Accounts',
    payoutRequests: 'Payout Requests',
    fundedRequests: 'Funded Phase Requests',
    affiliateWithdrawals: 'Affiliate Withdrawals',
    createAccount: 'Create Account',
    editAccount: 'Edit Account',
    deleteAccount: 'Delete Account',
    approve: 'Approve',
    decline: 'Decline',
    markAsPaid: 'Mark as Paid',
    reset: 'Reset',
    search: 'Search users...',
    selectUser: 'Select User',
    selectStatus: 'Select Status',
    all: 'All',
    active: 'Active',
    funded: 'Funded',
    breached: 'Breached',
    pending: 'Pending',
    approved: 'Approved',
    declined: 'Declined',
    paid: 'Paid',
    noResults: 'No results found',
    confirmDelete: 'Are you sure you want to delete this account?',
    accountCreated: 'Account created successfully',
    accountUpdated: 'Account updated successfully',
    accountDeleted: 'Account deleted successfully',
    requestApproved: 'Request approved successfully',
    requestDeclined: 'Request declined successfully'
  },
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    or: 'or',
    and: 'and',
    of: 'of',
    to: 'to',
    from: 'from',
    days: 'days',
    hours: 'hours'
  }
};

// Spanish translations
const es = {
  nav: {
    howItWorks: 'Cómo Funciona',
    accountPlans: 'Planes de Cuenta',
    tradingRules: 'Reglas de Trading',
    dashboard: 'Panel',
    faq: 'Preguntas',
    login: 'Iniciar Sesión',
    getFunded: 'Obtener Fondos',
    logout: 'Cerrar Sesión'
  },
  hero: {
    badge: 'Firma de Prop Trading Premium',
    title: 'Opera Índices Sintéticos con',
    titleHighlight: 'Capital Institucional',
    subtitle: 'Obtén financiamiento instantáneo hasta $50,000 y opera Índices Sintéticos Deriv 24/7. Sin evaluación para planes INSTANT.',
    instantFunding: 'Financiamiento Instantáneo',
    profitSplit: '80% División de Ganancias',
    trading247: 'Trading 24/7',
    getFundedNow: 'Obtener Fondos Ahora',
    viewRules: 'Ver Reglas'
  },
  stats: {
    fundedTraders: 'Traders Financiados',
    totalPayouts: 'Pagos Totales',
    successRate: 'Tasa de Éxito',
    maxCapital: 'Capital Máximo'
  },
  plans: {
    title: 'Elige Tu Cuenta',
    subtitle: 'Selecciona el plan que coincida con tu estilo y objetivos de trading',
    instant: 'INSTANTÁNEO',
    oneStep: '1-PASO',
    instantDesc: 'Obtén fondos inmediatamente sin fase de evaluación',
    oneStepDesc: 'Pasa una fase de evaluación para obtener fondos',
    accountSize: 'Tamaño de Cuenta',
    price: 'Precio',
    dailyDrawdown: 'Drawdown Diario',
    maxDrawdown: 'Drawdown Máximo',
    profitTarget: 'Objetivo de Ganancia',
    profitSplit: 'División de Ganancias',
    minTradingDays: 'Días Mínimos de Trading',
    payoutFrequency: 'Frecuencia de Pago',
    leverage: 'Apalancamiento',
    consistencyRule: 'Regla de Consistencia',
    none: 'Ninguno',
    optional: 'Opcional',
    getStarted: 'Comenzar',
    popular: 'Popular',
    noEvaluation: 'Sin Evaluación',
    evaluation: 'Evaluación',
    features: 'Características',
    allFeatures: 'Todas las características incluidas',
    instantFunding: 'Financiamiento Instantáneo',
    noTimeLimits: 'Sin Límites de Tiempo',
    allStrategies: 'Todas las Estrategias Permitidas',
    eaAllowed: 'Trading con EA Permitido',
    scalpingAllowed: 'Scalping Permitido',
    weekendHolding: 'Posiciones de Fin de Semana Permitidas'
  },
  howItWorks: {
    title: 'Cómo Funciona',
    subtitle: 'Cuatro pasos simples para comenzar a operar con capital institucional',
    step1Title: 'Elige Tu Cuenta',
    step1Desc: 'Selecciona entre cuenta Instantánea o de 1 paso según tu estilo de trading',
    step2Title: 'Comienza a Operar',
    step2Desc: 'Opera Índices Sintéticos Deriv con gestión de riesgo institucional',
    step3Title: 'Cumple los Requisitos',
    step3Desc: 'Sigue nuestras reglas transparentes y demuestra rentabilidad consistente',
    step4Title: 'Retira Ganancias',
    step4Desc: 'Solicita retiros en 24-72 horas con tu división de ganancias'
  },
  tradingRules: {
    title: 'Reglas de Trading',
    subtitle: 'Reglas claras y transparentes diseñadas para tu éxito',
    instantRules: 'Reglas de Cuenta Instantánea',
    oneStepRules: 'Reglas de Cuenta 1-Paso',
    rule1Title: 'Drawdown Diario',
    rule1Desc: 'Límite máximo de pérdida diaria basado en el equity de tu cuenta',
    rule2Title: 'Drawdown Máximo',
    rule2Desc: 'Límite total de drawdown desde tu balance inicial',
    rule3Title: 'Objetivo de Ganancia',
    rule3Desc: '10% de objetivo de ganancia durante la fase de evaluación',
    rule4Title: 'Riesgo Abierto Máximo',
    rule4Desc: '1% de riesgo abierto máximo por operación',
    rule5Title: 'Consistencia de Ganancias',
    rule5Desc: 'Ningún día de trading puede contribuir más del 25% del beneficio total al retiro',
    rule6Title: 'Ciclo de Pago',
    rule6Desc: 'Solicita retiros cada 10 días con 80% de división de ganancias',
    rule7Title: 'Apalancamiento e Instrumentos',
    rule7Desc: 'Apalancamiento 1:1000 en Índices Sintéticos - trading 24/7 disponible',
    rule8Title: 'Días Mínimos de Trading',
    rule8Desc: 'Opcional - opera a tu propio ritmo sin requisitos mínimos',
    rule9Title: 'Sin Límite de Tiempo',
    rule9Desc: 'Opera a tu propio ritmo sin restricciones de tiempo',
    rule10Title: 'Todas las Estrategias',
    rule10Desc: 'EAs, scalping y todos los estilos de trading permitidos'
  },
  features: {
    title: 'Por Qué Elegirnos',
    subtitle: 'Características líderes en la industria diseñadas para traders serios',
    feature1Title: 'Financiamiento Instantáneo',
    feature1Desc: 'Obtén fondos inmediatamente después de la compra. Sin desafíos de evaluación.',
    feature2Title: 'Pagos Rápidos',
    feature2Desc: 'Retira tus ganancias en 24-72 horas. Múltiples métodos de pago.',
    feature3Title: 'Reglas Transparentes',
    feature3Desc: 'Reglas claras y directas. Sin condiciones ocultas.',
    feature4Title: 'Dashboard en Tiempo Real',
    feature4Desc: 'Rastrea tu rendimiento con análisis avanzados en tiempo real.',
    feature5Title: 'Modelo de Riesgo Institucional',
    feature5Desc: 'Sistemas profesionales de gestión de riesgo.',
    feature6Title: 'Soporte 24/7',
    feature6Desc: 'Equipo de soporte experto disponible las 24 horas.'
  },
  faq: {
    title: 'Preguntas Frecuentes',
    subtitle: 'Encuentra respuestas a preguntas comunes sobre nuestro programa',
    q1: '¿Cómo funciona el financiamiento instantáneo?',
    a1: 'Una vez que compras una cuenta, obtienes acceso inmediato a tu cuenta financiada. No se requiere fase de evaluación.',
    q2: '¿Qué son los Índices Sintéticos Deriv?',
    a2: 'Los índices sintéticos son mercados simulados que imitan movimientos del mercado real. Disponibles 24/7.',
    q3: '¿Qué tan rápido se procesan los pagos?',
    a3: 'Las solicitudes de retiro se procesan típicamente en 24-72 horas.',
    q4: '¿Puedo escalar mi cuenta?',
    a4: '¡Sí! Demuestra rentabilidad consistente y puedes escalar a cuentas más grandes.',
    q5: '¿Qué pasa si violo las reglas?',
    a5: 'Si violas los límites de drawdown, la cuenta será terminada. Puedes comprar una nueva cuenta.'
  },
  footer: {
    description: 'Firma de prop trading premium que ofrece cuentas financiadas para traders.',
    company: 'Empresa',
    aboutUs: 'Sobre Nosotros',
    howItWorks: 'Cómo Funciona',
    contact: 'Contacto',
    careers: 'Carreras',
    trading: 'Trading',
    accountPlans: 'Planes de Cuenta',
    tradingRules: 'Reglas de Trading',
    dashboard: 'Panel',
    payoutSystem: 'Sistema de Pagos',
    resources: 'Recursos',
    faq: 'Preguntas',
    blog: 'Blog',
    tradingGuide: 'Guía de Trading',
    videoTutorials: 'Tutoriales en Video',
    legal: 'Legal',
    termsConditions: 'Términos y Condiciones',
    privacyPolicy: 'Política de Privacidad',
    riskDisclosure: 'Divulgación de Riesgos',
    cookiePolicy: 'Política de Cookies',
    allRightsReserved: 'Todos los derechos reservados.',
    riskWarning: 'Advertencia de Riesgo: El trading implica un riesgo sustancial de pérdida.',
    riskDisclaimer: 'Aviso de Riesgo',
    riskDisclaimerText: 'El trading de índices sintéticos implica un riesgo sustancial de pérdida y no es adecuado para todos los inversores.'
  },
  auth: {
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    fullName: 'Nombre Completo',
    phone: 'Teléfono (Opcional)',
    forgotPassword: '¿Olvidaste tu Contraseña?',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    signUp: 'Registrarse',
    signIn: 'Iniciar Sesión',
    welcomeBack: 'Bienvenido de Nuevo',
    loginSubtitle: 'Inicia sesión para acceder a tu panel de trading',
    createAccount: 'Crear Cuenta',
    registerSubtitle: 'Comienza tu viaje de trading financiado hoy',
    resetPassword: 'Restablecer Contraseña',
    resetSubtitle: 'Ingresa tu email para recibir instrucciones',
    sendResetLink: 'Enviar Enlace',
    backToLogin: 'Volver a Iniciar Sesión',
    referralCode: 'Código de Referido (Opcional)',
    agreeToTerms: 'Acepto los Términos y Condiciones y la Política de Privacidad'
  },
  dashboard: {
    welcome: 'Bienvenido de nuevo',
    myAccounts: 'Mis Cuentas',
    payoutRequests: 'Solicitudes de Pago',
    purchaseHistory: 'Historial de Compras',
    achievements: 'Logros',
    affiliate: 'Afiliado',
    noAccounts: 'Sin Cuentas de Trading',
    noAccountsDesc: 'Compra un plan para comenzar con tu cuenta financiada',
    viewPlans: 'Ver Planes',
    requestPayout: 'Solicitar Pago',
    requestFundedPhase: 'Solicitar Fase Financiada',
    credentials: 'Credenciales MT5',
    loginId: 'ID de Inicio',
    password: 'Contraseña',
    server: 'Servidor',
    status: 'Estado',
    phase: 'Fase',
    dailyDD: 'DD Diario',
    maxDD: 'DD Máximo',
    profitSplit: 'División de Ganancias',
    profitTarget: 'Objetivo de Ganancia',
    accountSize: 'Tamaño de Cuenta',
    accountType: 'Tipo de Cuenta',
    createdAt: 'Creado',
    notes: 'Notas',
    active: 'Activo',
    funded: 'Financiado',
    breached: 'Violado',
    pending: 'Pendiente',
    evaluation: 'Evaluación',
    copyCredentials: 'Copiar Credenciales',
    copied: '¡Copiado!',
    logout: 'Cerrar Sesión'
  },
  payout: {
    title: 'Solicitar Pago',
    subtitle: 'Retira tus ganancias de trading',
    amount: 'Monto',
    profitAmount: 'Monto de Ganancia',
    cryptocurrency: 'Criptomoneda',
    walletAddress: 'Dirección de Billetera',
    submit: 'Enviar Solicitud',
    cancel: 'Cancelar',
    minAmount: 'Monto mínimo de pago',
    maxAmount: 'Máximo disponible',
    selectCrypto: 'Seleccionar criptomoneda',
    enterWallet: 'Ingresa tu dirección de billetera',
    requestSubmitted: '¡Solicitud de pago enviada exitosamente!',
    requestFailed: 'Error al enviar solicitud de pago',
    noProfits: 'No hay ganancias disponibles para retiro',
    pendingRequest: 'Tienes una solicitud de pago pendiente'
  },
  payment: {
    completePayment: 'Completar Pago',
    selectCurrency: 'Seleccionar Moneda de Pago',
    amountToPay: 'Monto a Pagar',
    payWith: 'Pagar con',
    processing: 'Procesando...',
    payNow: 'Pagar Ahora',
    secure: 'Pago seguro con NowPayments',
    orderSummary: 'Resumen del Pedido',
    accountType: 'Tipo de Cuenta',
    accountSize: 'Tamaño de Cuenta',
    price: 'Precio',
    total: 'Total'
  },
  affiliate: {
    title: 'Programa de Afiliados',
    subtitle: 'Gana 10% de comisión por cada referido',
    yourLink: 'Tu Enlace de Referido',
    copyLink: 'Copiar Enlace',
    linkCopied: '¡Enlace copiado!',
    stats: 'Tus Estadísticas',
    totalReferrals: 'Total de Referidos',
    totalEarned: 'Total Ganado',
    pendingBalance: 'Saldo Pendiente',
    withdrawableBalance: 'Saldo Retirable',
    withdrawThreshold: 'Retiro mínimo: $150',
    requestWithdrawal: 'Solicitar Retiro',
    referralHistory: 'Historial de Referidos',
    noReferrals: 'Sin referidos aún. ¡Comparte tu enlace para empezar a ganar!',
    withdrawalHistory: 'Historial de Retiros',
    noWithdrawals: 'Sin historial de retiros',
    howItWorks: 'Cómo Funciona',
    step1: 'Comparte tu enlace único de referido',
    step2: 'Tus amigos se registran y compran',
    step3: 'Gana 10% de comisión instantáneamente',
    step4: 'Retira cuando tu saldo llegue a $150'
  },
  certificates: {
    title: 'Logros',
    subtitle: 'Tus certificados y logros de trading',
    fundedCertificate: 'Certificado de Financiamiento',
    payoutCertificate: 'Certificado de Pago',
    download: 'Descargar',
    share: 'Compartir',
    noCertificates: 'Sin Certificados Aún',
    noCertificatesDesc: 'Los certificados se otorgan cuando tu cuenta es financiada o recibes un pago aprobado.',
    shareAchievement: 'Comparte Tu Logro',
    shareMessage: '¡Deja que el mundo sepa de tu éxito!'
  },
  admin: {
    dashboard: 'Panel de Admin',
    users: 'Usuarios',
    accounts: 'Cuentas',
    payoutRequests: 'Solicitudes de Pago',
    fundedRequests: 'Solicitudes de Fase Financiada',
    affiliateWithdrawals: 'Retiros de Afiliados',
    createAccount: 'Crear Cuenta',
    editAccount: 'Editar Cuenta',
    deleteAccount: 'Eliminar Cuenta',
    approve: 'Aprobar',
    decline: 'Rechazar',
    markAsPaid: 'Marcar como Pagado',
    reset: 'Restablecer',
    search: 'Buscar usuarios...',
    selectUser: 'Seleccionar Usuario',
    selectStatus: 'Seleccionar Estado',
    all: 'Todos',
    active: 'Activo',
    funded: 'Financiado',
    breached: 'Violado',
    pending: 'Pendiente',
    approved: 'Aprobado',
    declined: 'Rechazado',
    paid: 'Pagado',
    noResults: 'Sin resultados',
    confirmDelete: '¿Estás seguro de eliminar esta cuenta?',
    accountCreated: 'Cuenta creada exitosamente',
    accountUpdated: 'Cuenta actualizada exitosamente',
    accountDeleted: 'Cuenta eliminada exitosamente',
    requestApproved: 'Solicitud aprobada exitosamente',
    requestDeclined: 'Solicitud rechazada exitosamente'
  },
  common: {
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    submit: 'Enviar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    sort: 'Ordenar',
    yes: 'Sí',
    no: 'No',
    ok: 'OK',
    or: 'o',
    and: 'y',
    of: 'de',
    to: 'a',
    from: 'desde',
    days: 'días',
    hours: 'horas'
  }
};

// French translations
const fr = {
  nav: {
    howItWorks: 'Comment ça Marche',
    accountPlans: 'Plans de Compte',
    tradingRules: 'Règles de Trading',
    dashboard: 'Tableau de Bord',
    faq: 'FAQ',
    login: 'Connexion',
    getFunded: 'Être Financé',
    logout: 'Déconnexion'
  },
  hero: {
    badge: 'Société de Prop Trading Premium',
    title: 'Tradez les Indices Synthétiques avec',
    titleHighlight: 'Capital Institutionnel',
    subtitle: 'Obtenez un financement instantané jusqu\'à 50 000$ et tradez les Indices Synthétiques Deriv 24/7.',
    instantFunding: 'Financement Instantané',
    profitSplit: '80% Partage des Profits',
    trading247: 'Trading 24/7',
    getFundedNow: 'Être Financé Maintenant',
    viewRules: 'Voir les Règles'
  },
  stats: {
    fundedTraders: 'Traders Financés',
    totalPayouts: 'Paiements Totaux',
    successRate: 'Taux de Réussite',
    maxCapital: 'Capital Maximum'
  },
  plans: {
    title: 'Choisissez Votre Compte',
    subtitle: 'Sélectionnez le plan qui correspond à votre style de trading',
    instant: 'INSTANTANÉ',
    oneStep: '1-ÉTAPE',
    instantDesc: 'Soyez financé immédiatement sans phase d\'évaluation',
    oneStepDesc: 'Passez une phase d\'évaluation pour être financé',
    accountSize: 'Taille du Compte',
    price: 'Prix',
    dailyDrawdown: 'Drawdown Journalier',
    maxDrawdown: 'Drawdown Maximum',
    profitTarget: 'Objectif de Profit',
    profitSplit: 'Partage des Profits',
    minTradingDays: 'Jours de Trading Minimum',
    payoutFrequency: 'Fréquence de Paiement',
    leverage: 'Effet de Levier',
    consistencyRule: 'Règle de Cohérence',
    none: 'Aucun',
    optional: 'Optionnel',
    getStarted: 'Commencer',
    popular: 'Populaire',
    noEvaluation: 'Sans Évaluation',
    evaluation: 'Évaluation',
    features: 'Fonctionnalités',
    allFeatures: 'Toutes les fonctionnalités incluses',
    instantFunding: 'Financement Instantané',
    noTimeLimits: 'Sans Limite de Temps',
    allStrategies: 'Toutes Stratégies Autorisées',
    eaAllowed: 'Trading EA Autorisé',
    scalpingAllowed: 'Scalping Autorisé',
    weekendHolding: 'Positions Week-end Autorisées'
  },
  howItWorks: {
    title: 'Comment ça Marche',
    subtitle: 'Quatre étapes simples pour trader avec du capital institutionnel',
    step1Title: 'Choisissez Votre Compte',
    step1Desc: 'Sélectionnez entre compte Instantané ou 1-Étape selon votre style',
    step2Title: 'Commencez à Trader',
    step2Desc: 'Tradez les Indices Synthétiques Deriv avec gestion de risque institutionnelle',
    step3Title: 'Remplissez les Conditions',
    step3Desc: 'Suivez nos règles transparentes et démontrez une rentabilité constante',
    step4Title: 'Retirez vos Profits',
    step4Desc: 'Demandez des retraits en 24-72 heures avec votre partage de profits'
  },
  tradingRules: {
    title: 'Règles de Trading',
    subtitle: 'Des règles claires et transparentes conçues pour votre succès',
    instantRules: 'Règles Compte Instantané',
    oneStepRules: 'Règles Compte 1-Étape',
    rule1Title: 'Drawdown Journalier',
    rule1Desc: 'Limite de perte quotidienne maximale basée sur l\'équité',
    rule2Title: 'Drawdown Maximum',
    rule2Desc: 'Limite totale de drawdown depuis le solde initial',
    rule3Title: 'Objectif de Profit',
    rule3Desc: '10% d\'objectif de profit pendant la phase d\'évaluation',
    rule4Title: 'Risque Ouvert Maximum',
    rule4Desc: '1% de risque ouvert maximum par trade',
    rule5Title: 'Cohérence des Profits',
    rule5Desc: 'Aucun jour de trading ne peut contribuer plus de 25% du profit total',
    rule6Title: 'Cycle de Paiement',
    rule6Desc: 'Demandez des retraits tous les 10 jours avec 80% de partage',
    rule7Title: 'Levier & Instruments',
    rule7Desc: 'Levier 1:1000 sur Indices Synthétiques - trading 24/7 disponible',
    rule8Title: 'Jours de Trading Minimum',
    rule8Desc: 'Optionnel - tradez à votre rythme sans exigences minimum',
    rule9Title: 'Sans Limite de Temps',
    rule9Desc: 'Tradez à votre rythme sans restrictions de temps',
    rule10Title: 'Toutes Stratégies',
    rule10Desc: 'EAs, scalping et tous les styles de trading autorisés'
  },
  features: {
    title: 'Pourquoi Nous Choisir',
    subtitle: 'Fonctionnalités leaders de l\'industrie pour traders sérieux',
    feature1Title: 'Financement Instantané',
    feature1Desc: 'Soyez financé immédiatement après l\'achat. Sans défis d\'évaluation.',
    feature2Title: 'Paiements Rapides',
    feature2Desc: 'Retirez vos profits en 24-72 heures. Plusieurs méthodes de paiement.',
    feature3Title: 'Règles Transparentes',
    feature3Desc: 'Règles claires et directes. Sans conditions cachées.',
    feature4Title: 'Dashboard Temps Réel',
    feature4Desc: 'Suivez vos performances avec des analyses avancées en temps réel.',
    feature5Title: 'Modèle de Risque Institutionnel',
    feature5Desc: 'Systèmes professionnels de gestion des risques.',
    feature6Title: 'Support 24/7',
    feature6Desc: 'Équipe de support experte disponible 24h/24.'
  },
  faq: {
    title: 'Questions Fréquentes',
    subtitle: 'Trouvez des réponses aux questions courantes sur notre programme',
    q1: 'Comment fonctionne le financement instantané?',
    a1: 'Une fois votre compte acheté, vous obtenez un accès immédiat à votre compte financé. Aucune phase d\'évaluation requise.',
    q2: 'Que sont les Indices Synthétiques Deriv?',
    a2: 'Les indices synthétiques sont des marchés simulés qui imitent les mouvements du marché réel. Disponibles 24/7.',
    q3: 'Quelle est la vitesse de traitement des paiements?',
    a3: 'Les demandes de retrait sont généralement traitées en 24-72 heures.',
    q4: 'Puis-je faire évoluer mon compte?',
    a4: 'Oui! Démontrez une rentabilité constante et vous pouvez évoluer vers des comptes plus grands.',
    q5: 'Que se passe-t-il si je viole les règles?',
    a5: 'Si vous violez les limites de drawdown, le compte sera résilié. Vous pouvez acheter un nouveau compte.'
  },
  footer: {
    description: 'Société de prop trading premium offrant des comptes financés aux traders.',
    company: 'Entreprise',
    aboutUs: 'À Propos',
    howItWorks: 'Comment ça Marche',
    contact: 'Contact',
    careers: 'Carrières',
    trading: 'Trading',
    accountPlans: 'Plans de Compte',
    tradingRules: 'Règles de Trading',
    dashboard: 'Tableau de Bord',
    payoutSystem: 'Système de Paiement',
    resources: 'Ressources',
    faq: 'FAQ',
    blog: 'Blog',
    tradingGuide: 'Guide de Trading',
    videoTutorials: 'Tutoriels Vidéo',
    legal: 'Légal',
    termsConditions: 'Conditions Générales',
    privacyPolicy: 'Politique de Confidentialité',
    riskDisclosure: 'Divulgation des Risques',
    cookiePolicy: 'Politique des Cookies',
    allRightsReserved: 'Tous droits réservés.',
    riskWarning: 'Avertissement: Le trading comporte un risque substantiel de perte.',
    riskDisclaimer: 'Avertissement sur les Risques',
    riskDisclaimerText: 'Le trading d\'indices synthétiques comporte un risque substantiel de perte.'
  },
  auth: {
    login: 'Connexion',
    register: 'S\'inscrire',
    email: 'Email',
    password: 'Mot de Passe',
    fullName: 'Nom Complet',
    phone: 'Téléphone (Optionnel)',
    forgotPassword: 'Mot de Passe Oublié?',
    noAccount: 'Pas de compte?',
    hasAccount: 'Déjà un compte?',
    signUp: 'S\'inscrire',
    signIn: 'Se Connecter',
    welcomeBack: 'Bienvenue',
    loginSubtitle: 'Connectez-vous pour accéder à votre tableau de bord',
    createAccount: 'Créer un Compte',
    registerSubtitle: 'Commencez votre parcours de trading financé aujourd\'hui',
    resetPassword: 'Réinitialiser le Mot de Passe',
    resetSubtitle: 'Entrez votre email pour recevoir les instructions',
    sendResetLink: 'Envoyer le Lien',
    backToLogin: 'Retour à la Connexion',
    referralCode: 'Code de Parrainage (Optionnel)',
    agreeToTerms: 'J\'accepte les Conditions Générales et la Politique de Confidentialité'
  },
  dashboard: {
    welcome: 'Bienvenue',
    myAccounts: 'Mes Comptes',
    payoutRequests: 'Demandes de Paiement',
    purchaseHistory: 'Historique d\'Achats',
    achievements: 'Réalisations',
    affiliate: 'Affiliation',
    noAccounts: 'Pas de Comptes de Trading',
    noAccountsDesc: 'Achetez un plan pour commencer avec votre compte financé',
    viewPlans: 'Voir les Plans',
    requestPayout: 'Demander un Paiement',
    requestFundedPhase: 'Demander la Phase Financée',
    credentials: 'Identifiants MT5',
    loginId: 'ID de Connexion',
    password: 'Mot de Passe',
    server: 'Serveur',
    status: 'Statut',
    phase: 'Phase',
    dailyDD: 'DD Journalier',
    maxDD: 'DD Maximum',
    profitSplit: 'Partage des Profits',
    profitTarget: 'Objectif de Profit',
    accountSize: 'Taille du Compte',
    accountType: 'Type de Compte',
    createdAt: 'Créé',
    notes: 'Notes',
    active: 'Actif',
    funded: 'Financé',
    breached: 'Violé',
    pending: 'En Attente',
    evaluation: 'Évaluation',
    copyCredentials: 'Copier les Identifiants',
    copied: 'Copié!',
    logout: 'Déconnexion'
  },
  payout: {
    title: 'Demander un Paiement',
    subtitle: 'Retirez vos profits de trading',
    amount: 'Montant',
    profitAmount: 'Montant du Profit',
    cryptocurrency: 'Cryptomonnaie',
    walletAddress: 'Adresse du Portefeuille',
    submit: 'Soumettre la Demande',
    cancel: 'Annuler',
    minAmount: 'Montant minimum de paiement',
    maxAmount: 'Maximum disponible',
    selectCrypto: 'Sélectionner la cryptomonnaie',
    enterWallet: 'Entrez votre adresse de portefeuille',
    requestSubmitted: 'Demande de paiement soumise avec succès!',
    requestFailed: 'Échec de la soumission de la demande',
    noProfits: 'Pas de profits disponibles pour le retrait',
    pendingRequest: 'Vous avez une demande de paiement en attente'
  },
  payment: {
    completePayment: 'Effectuer le Paiement',
    selectCurrency: 'Sélectionner la Devise de Paiement',
    amountToPay: 'Montant à Payer',
    payWith: 'Payer avec',
    processing: 'Traitement...',
    payNow: 'Payer Maintenant',
    secure: 'Paiement sécurisé par NowPayments',
    orderSummary: 'Résumé de la Commande',
    accountType: 'Type de Compte',
    accountSize: 'Taille du Compte',
    price: 'Prix',
    total: 'Total'
  },
  affiliate: {
    title: 'Programme d\'Affiliation',
    subtitle: 'Gagnez 10% de commission sur chaque parrainage',
    yourLink: 'Votre Lien de Parrainage',
    copyLink: 'Copier le Lien',
    linkCopied: 'Lien copié!',
    stats: 'Vos Statistiques',
    totalReferrals: 'Total des Parrainages',
    totalEarned: 'Total Gagné',
    pendingBalance: 'Solde en Attente',
    withdrawableBalance: 'Solde Retirable',
    withdrawThreshold: 'Retrait minimum: 150$',
    requestWithdrawal: 'Demander un Retrait',
    referralHistory: 'Historique des Parrainages',
    noReferrals: 'Pas encore de parrainages. Partagez votre lien pour commencer à gagner!',
    withdrawalHistory: 'Historique des Retraits',
    noWithdrawals: 'Pas d\'historique de retrait',
    howItWorks: 'Comment ça Marche',
    step1: 'Partagez votre lien unique de parrainage',
    step2: 'Vos amis s\'inscrivent et achètent',
    step3: 'Gagnez 10% de commission instantanément',
    step4: 'Retirez quand votre solde atteint 150$'
  },
  certificates: {
    title: 'Réalisations',
    subtitle: 'Vos certificats et réalisations de trading',
    fundedCertificate: 'Certificat de Financement',
    payoutCertificate: 'Certificat de Paiement',
    download: 'Télécharger',
    share: 'Partager',
    noCertificates: 'Pas Encore de Certificats',
    noCertificatesDesc: 'Les certificats sont attribués lorsque votre compte est financé ou lorsque vous recevez un paiement approuvé.',
    shareAchievement: 'Partagez Votre Réalisation',
    shareMessage: 'Faites connaître votre succès au monde!'
  },
  admin: {
    dashboard: 'Tableau de Bord Admin',
    users: 'Utilisateurs',
    accounts: 'Comptes',
    payoutRequests: 'Demandes de Paiement',
    fundedRequests: 'Demandes Phase Financée',
    affiliateWithdrawals: 'Retraits d\'Affiliation',
    createAccount: 'Créer un Compte',
    editAccount: 'Modifier le Compte',
    deleteAccount: 'Supprimer le Compte',
    approve: 'Approuver',
    decline: 'Refuser',
    markAsPaid: 'Marquer comme Payé',
    reset: 'Réinitialiser',
    search: 'Rechercher des utilisateurs...',
    selectUser: 'Sélectionner un Utilisateur',
    selectStatus: 'Sélectionner le Statut',
    all: 'Tous',
    active: 'Actif',
    funded: 'Financé',
    breached: 'Violé',
    pending: 'En Attente',
    approved: 'Approuvé',
    declined: 'Refusé',
    paid: 'Payé',
    noResults: 'Aucun résultat',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce compte?',
    accountCreated: 'Compte créé avec succès',
    accountUpdated: 'Compte mis à jour avec succès',
    accountDeleted: 'Compte supprimé avec succès',
    requestApproved: 'Demande approuvée avec succès',
    requestDeclined: 'Demande refusée avec succès'
  },
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    submit: 'Soumettre',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    yes: 'Oui',
    no: 'Non',
    ok: 'OK',
    or: 'ou',
    and: 'et',
    of: 'de',
    to: 'à',
    from: 'de',
    days: 'jours',
    hours: 'heures'
  }
};

// For other languages, we'll use the same structure with translations
// Portuguese
const pt = { ...es }; // Using Spanish as base, adjust keys as needed
pt.nav = { howItWorks: 'Como Funciona', accountPlans: 'Planos de Conta', tradingRules: 'Regras de Trading', dashboard: 'Painel', faq: 'Perguntas', login: 'Entrar', getFunded: 'Obter Financiamento', logout: 'Sair' };
pt.hero = { badge: 'Empresa de Prop Trading Premium', title: 'Negocie Índices Sintéticos com', titleHighlight: 'Capital Institucional', subtitle: 'Obtenha financiamento instantâneo até $50.000 e negocie Índices Sintéticos Deriv 24/7.', instantFunding: 'Financiamento Instantâneo', profitSplit: '80% Divisão de Lucros', trading247: 'Trading 24/7', getFundedNow: 'Obter Financiamento Agora', viewRules: 'Ver Regras' };

// Arabic
const ar = { ...en };
ar.nav = { howItWorks: 'كيف يعمل', accountPlans: 'خطط الحساب', tradingRules: 'قواعد التداول', dashboard: 'لوحة التحكم', faq: 'الأسئلة الشائعة', login: 'تسجيل الدخول', getFunded: 'احصل على التمويل', logout: 'تسجيل الخروج' };
ar.hero = { badge: 'شركة تداول ممولة متميزة', title: 'تداول المؤشرات الاصطناعية مع', titleHighlight: 'رأس المال المؤسسي', subtitle: 'احصل على تمويل فوري يصل إلى 50,000 دولار وتداول مؤشرات Deriv الاصطناعية على مدار الساعة.', instantFunding: 'تمويل فوري', profitSplit: '80% من الأرباح', trading247: 'تداول 24/7', getFundedNow: 'احصل على التمويل الآن', viewRules: 'عرض القواعد' };

// Chinese
const zh = { ...en };
zh.nav = { howItWorks: '如何运作', accountPlans: '账户计划', tradingRules: '交易规则', dashboard: '仪表板', faq: '常见问题', login: '登录', getFunded: '获得资金', logout: '退出登录' };
zh.hero = { badge: '高端自营交易公司', title: '使用机构资本交易', titleHighlight: '合成指数', subtitle: '获得高达50,000美元的即时资金，全天候交易Deriv合成指数。', instantFunding: '即时资金', profitSplit: '80%利润分成', trading247: '24/7交易', getFundedNow: '立即获得资金', viewRules: '查看规则' };

// Hausa
const ha = { ...en };
ha.nav = { howItWorks: 'Yadda Yake Aiki', accountPlans: 'Shirye-shiryen Asusu', tradingRules: 'Dokokin Kasuwanci', dashboard: 'Dashboard', faq: 'Tambayoyi', login: 'Shiga', getFunded: 'Samu Kudi', logout: 'Fita' };
ha.hero = { badge: 'Kamfanin Kasuwanci na Premium', title: 'Yi Kasuwanci da Synthetic Indices tare da', titleHighlight: 'Babban Jari', subtitle: 'Samu kuɗi nan take har zuwa $50,000 kuma yi kasuwanci da Deriv Synthetic Indices 24/7.', instantFunding: 'Kuɗi Nan Take', profitSplit: '80% Raba Riba', trading247: 'Kasuwanci 24/7', getFundedNow: 'Samu Kuɗi Yanzu', viewRules: 'Duba Dokoki' };

// Afrikaans
const af = { ...en };
af.nav = { howItWorks: 'Hoe Dit Werk', accountPlans: 'Rekeningplanne', tradingRules: 'Handelsreëls', dashboard: 'Paneelbord', faq: 'Vrae', login: 'Teken In', getFunded: 'Kry Befondsing', logout: 'Teken Uit' };
af.hero = { badge: 'Premium Prop Handelsonderneming', title: 'Verhandel Sintetiese Indekse met', titleHighlight: 'Institusionele Kapitaal', subtitle: 'Kry onmiddellike befondsing tot $50,000 en verhandel Deriv Sintetiese Indekse 24/7.', instantFunding: 'Onmiddellike Befondsing', profitSplit: '80% Winsverdeling', trading247: '24/7 Handel', getFundedNow: 'Kry Nou Befondsing', viewRules: 'Sien Reëls' };

// Igbo
const ig = { ...en };
ig.nav = { howItWorks: 'Otu Ọ Si Arụ Ọrụ', accountPlans: 'Atụmatụ Akaụntụ', tradingRules: 'Iwu Azụmahịa', dashboard: 'Dashboard', faq: 'Ajụjụ', login: 'Banye', getFunded: 'Nweta Ego', logout: 'Pụọ' };
ig.hero = { badge: 'Ụlọ Ọrụ Azụmahịa Premium', title: 'Zụọ Ahịa Synthetic Indices site na', titleHighlight: 'Ego Nnukwu Ụlọ Ọrụ', subtitle: 'Nweta ego ozugbo ruo $50,000 ma zụọ ahịa Deriv Synthetic Indices ụbọchị 24/7.', instantFunding: 'Ego Ozugbo', profitSplit: '80% Nkewa Uru', trading247: 'Azụmahịa 24/7', getFundedNow: 'Nweta Ego Ugbu a', viewRules: 'Lee Iwu' };

// Yoruba
const yo = { ...en };
yo.nav = { howItWorks: 'Bí Ó Ṣe Ń Ṣiṣẹ́', accountPlans: 'Àwọn Ètò Àkọọ́lẹ̀', tradingRules: 'Àwọn Òfin Ìṣòwò', dashboard: 'Dashboard', faq: 'Àwọn Ìbéèrè', login: 'Wọlé', getFunded: 'Gba Owó', logout: 'Jáde' };
yo.hero = { badge: 'Ilé-iṣẹ́ Ìṣòwò Premium', title: 'Ṣòwò Synthetic Indices pẹ̀lú', titleHighlight: 'Owó Ilé-iṣẹ́', subtitle: 'Gba owó lẹ́sẹ̀kẹsẹ̀ tó $50,000 kí o sì ṣòwò Deriv Synthetic Indices 24/7.', instantFunding: 'Owó Lẹ́sẹ̀kẹsẹ̀', profitSplit: '80% Ìpín Èrè', trading247: 'Ìṣòwò 24/7', getFundedNow: 'Gba Owó Báyìí', viewRules: 'Wo Àwọn Òfin' };

export const translations = { en, es, fr, pt, ar, zh, ha, af, ig, yo };

export default translations;
